import "./style.scss";

import Button from "shared/ui/Button";
import { Button_Type } from "shared/ui/Button/Button";
import { FC, useEffect, useState } from "react";
import frenchTech from "../../assets/img/Logo_French_Tech.png";
import illu from "../../assets/img/Illustration_IDS.png";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "shared/ui/Modal";
import { decryptApiBodyToString } from "shared/api/cryptApiBody";
import { checkStillConnected, loginWithSSO } from "features/auth";

type HomeProps = {
    forOnlyPartner?: boolean,
    forADVEnableSSO?: boolean,
}


const Home: FC<HomeProps> = ({forOnlyPartner = false, forADVEnableSSO=true}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [showModal, setShowModal] = useState<boolean>(false);
    const [messageError, setMessageError] = useState<string | null>('');

    useEffect(() => {
        const rawSearch = location.search;
        // Pour éviter que le `+` soit transformé en espace :
        const rawErrorParam = rawSearch.match(/[?&]error=([^&]*)/);
        const rawTypeParam = rawSearch.match(/[?&]type=([^&]*)/);
        const rawTokenParam = rawSearch.match(/[?&]token=([^&]*)/);
        const searchParamsError = rawErrorParam ? decodeURIComponent(rawErrorParam[1]) : '';
        const searchParamsType = rawTypeParam ? decodeURIComponent(rawTypeParam[1]) : '';
        const searchParamsToken = rawTokenParam ? decodeURIComponent(rawTokenParam[1]) : '';

        const error = decryptApiBodyToString(searchParamsError ?? '');
        const type = decryptApiBodyToString(searchParamsType ?? '');
        const token = decryptApiBodyToString(searchParamsToken ?? '');

        if (type === "partner" || type === 'individual') {
            setMessageError(null);
            goToNextPage(type, token);
        } else if (error !== '') {
            setMessageError(error);
            setShowModal(true);
        } else {
            setMessageError(null);
            setShowModal(false);
        }


        if (error !== '') {
            setMessageError(error);
            setShowModal(true);
        } else {
            setMessageError(null);
            setShowModal(false);
        }

    }, [location, navigate]);

    const goToNextPage = async (type: string, token= '') => {
        if (await checkStillConnected(type, token)) {
            localStorage.setItem("type", type);
            if (forOnlyPartner) {
                navigate("/professionnels/base-de-donnees"); // redirection automatique
            } else {
                navigate(`${type === 'partner' ? '/professionnels' : '/particuliers'}/dashboard`);
            }
        }
    }

    return (
        <>
            <div className="home">
                <div className="container row">
                    <div className="col-lg-7 home__content">
                        <h1 className="home__title">
                            Le 1er moyen de <br />
                            prévention contre <br />{" "}
                            <span className="home__title__tag">
                                <span className="gradient">l'usurpation</span> <span className="color">d'identité</span>
                            </span>
                        </h1>
                        <h2 className="home__subtitle">L'application ID Protect</h2>
                        <div className="home__desc">
                            <p>ID Protect prévient l’usurpation d’identité grâce à des outils innovants.</p>
                            <p>Particuliers, protégez vos documents et facilitez vos démarches en ligne .</p>
                            <p>Professionnels, prévenez facilement les cas d’usurpation.</p>
                        </div>
                        {forOnlyPartner && (<div className="home__buttons">
                            <Button
                                label="Connexion"
                                type={Button_Type.SECONDARY}
                                onClick={async () => forADVEnableSSO ? await loginWithSSO() : navigate("/professionnels/login")}
                            />
                        </div>)}
                        {!forOnlyPartner &&
                            (<div className="home__buttons">
                                <Button
                                    label="Particuliers"
                                    onClick={() => navigate("/particuliers/login")}
                                />
                                <Button
                                    label="Professionnels"
                                    type={Button_Type.SECONDARY}
                                    onClick={() => navigate("/professionnels/login")}
                                />
                            </div>)
                        }
                    </div>
                    <div className="col-lg-5 home__illu">
                        <img
                            src={frenchTech}
                            alt="Logo French Tech"
                        />
                        <img
                            src={illu}
                            alt="ID Protect Documents d'identité"
                            className="mt-auto d-block"
                        />
                    </div>
                </div>
            </div>

            {showModal && (
                <Modal onClose={() => setShowModal(false)} isOpen={showModal} title="Echec de connexion" infoModal
                       type="error">
                    <div className="w-100 text-center center">
                        {messageError}
                        <br/>
                        <b>Veuillez vous connecter à nouveau</b>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default Home;

/*
import "./style.scss";

import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import React, { FC, useEffect, useState } from "react";
import frenchTech from "../../assets/img/Logo_French_Tech.png";
import illu from "../../assets/img/Illustration_IDS.png";
import { useLocation, useNavigate } from "react-router-dom";
import { decryptApiBodyToJson, decryptApiBodyToString } from "shared/api/cryptApiBody";
import { checkStillConnected, loginWithSSO } from "features/auth";
import Modal from "shared/ui/Modal";

type HomeProps = {
    forOnlyPartner?: boolean,
}


const Home: FC<HomeProps> = ({forOnlyPartner = false}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [showModal, setShowModal] = useState<boolean>(false);
    const [messageError, setMessageError] = useState<string | null>('');

    useEffect(() => {
        const rawSearch = location.search;
        // Pour éviter que le `+` soit transformé en espace :
        const rawErrorParam = rawSearch.match(/[?&]error=([^&]*)/);
        const rawTypeParam = rawSearch.match(/[?&]type=([^&]*)/);
        const searchParamsError = rawErrorParam ? decodeURIComponent(rawErrorParam[1]) : '';
        const searchParamsType = rawTypeParam ? decodeURIComponent(rawTypeParam[1]) : '';

        const error = decryptApiBodyToString(searchParamsError ?? '');
        const type = decryptApiBodyToString(searchParamsType ?? '');

        // console.log(searchParamsType);

       if (type === "partner") {
            if (forOnlyPartner){
                setMessageError(null);
                goToNextPage(type);
            }
       } else if (error !== '') {
           setMessageError(error);
           setShowModal(true);
       } else {
           setMessageError(null);
           setShowModal(false);
       }

    }, [location, navigate]);

    const goToNextPage = async (type: string) => {
        if (await checkStillConnected(type)) {
            localStorage.setItem("type", type);
            navigate("/professionnels/base-de-donnees"); // redirection automatique
        }
    }

    return (
        <>
            <div className="home">
                <div className="container row">
                    <div className="col-lg-7 home__content">
                        <h1 className="home__title">
                            Le 1er moyen de <br />
                            prévention contre <br />{" "}
                            <span className="home__title__tag">
                                <span className="gradient">l'usurpation</span> <span className="color">d'identité</span>
                            </span>
                        </h1>
                        <h2 className="home__subtitle">L'application ID Protect</h2>
                        <div className="home__desc">
                            <p>ID Protect prévient l’usurpation d’identité grâce à des outils innovants.</p>
                            <p>Particuliers, protégez vos documents et facilitez vos démarches en ligne .</p>
                            <p>Professionnels, prévenez facilement les cas d’usurpation.</p>
                        </div>
                        {forOnlyPartner && (<div className="home__buttons">
                            <Button
                                label="Connexion"
                                type={Button_Type.SECONDARY}
                                onClick={async () => await loginWithSSO()}
                            />
                        </div>)}
                        {!forOnlyPartner &&
                            (<div className="home__buttons">
                            <Button
                                label="Particuliers"
                                onClick={() => navigate("/particuliers/login")}
                            />
                            <Button
                                label="Professionnels"
                                type={Button_Type.SECONDARY}
                                onClick={() => navigate("/professionnels/login")}
                            />
                            </div>)
                        }
                    </div>
                    <div className="col-lg-5 home__illu">
                        <img
                            src={frenchTech}
                            alt="Logo French Tech"
                        />
                        <img
                            src={illu}
                            alt="ID Protect Documents d'identité"
                            className="mt-auto d-block"
                        />
                    </div>
                </div>
            </div>

            {(showModal && forOnlyPartner) && (
                <Modal onClose={() => setShowModal(false)} isOpen={showModal} title="Echec de connexion" infoModal
                       type="error">
                    <div className="w-100 text-center center">
                        {messageError}
                        <br/>
                        <b>Veuillez vous reconnecter au SSO</b>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default Home;
*/